import styled from 'styled-components'
import Link from 'next/link'
import Image from 'next/legacy/image'
import PropTypes from 'prop-types'
import { H4 } from 'common/typography'
import ContentRenderer from 'content-renderer'

const NewProjectCardStyled = styled.div`
  color: var(--white);
  padding: 24px;
  background-image: linear-gradient(180.51deg, rgba(0, 0, 0, 0) 55.97%, #000000 72.46%);
  background-position: center;
  display: flex;
  justify-content: flex-end;
  border-radius: 8px;
  flex-direction: column;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  h4 {
    margin-bottom: 4px;
  }
  p {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .bg-card {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: -1;
  }
  @media (min-width: 768px) {
    background-size: cover;
  }
  @media (min-width: 1024px) {
    background-size: 591px 450px;
  }
`

function NewProjectCard({
  slug, cover_image, title, description: { blocks },
}) {
  return (
    <Link href={`/proyectos/${slug}`} passHref>
      <NewProjectCardStyled>
        <div className="bg-card">
          <Image
            alt="Mountains"
            src={cover_image}
            layout="fill"
            objectFit="cover"
          />
        </div>
        <H4>{title}</H4>
        <ContentRenderer chunks={blocks.slice(0, 1)} color="var(--white)" />
      </NewProjectCardStyled>
    </Link>
  )
}

NewProjectCard.propTypes = {
  slug: PropTypes.string.isRequired,
  cover_image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  description: PropTypes.any.isRequired,
  // description is the common object of our text editor in django
}

export default NewProjectCard
